const TEST_RESULT = Object.freeze({
  NA: 'na',
  PASS: 'pass',
  FAIL: 'fail'
})

const POWER_KEYS = [
  'pwr_fbvdd',
  'pwr_nvvdd',
  'pwr_tgp'
]

export {
  TEST_RESULT,
  POWER_KEYS
}
